import { ICombo, IComboSlot, IItem, MenuObject } from '@rbi-ctg/menu';
import { ILegacySelections, ProductProps } from 'components/product-detail-list-item/product/types';
import { IProductDetailListItemProps } from 'components/product-detail-list-item/types';
import { computeComboSlotCalories } from 'hooks/menu/utils';
import { ProductWizardUtils } from 'state/product-wizard-v2/utils';

import { getComboSlotOptionFromItem, transformItemToProductListItemProps } from '../utils';

import { TransformUserSelectionsToSummaryItemsFn } from './types';

const transformComboSlotToProductListItem = ({
  comboSlot,
  selectedProduct,
  selections,
}: {
  comboSlot: IComboSlot;
  selectedProduct?: MenuObject;
  selections?: ProductProps['selections'];
}): IProductDetailListItemProps => {
  const calories = String(computeComboSlotCalories(comboSlot));

  const name = comboSlot?.name?.locale ?? '';
  // use image for first comboSlot option if available, otherwise use main product image
  const image = JSON.stringify(comboSlot.options[0].option.image ?? selectedProduct?.image);

  return {
    productProps: {
      name,
      calories,
      image,
      isProductNameBold: true,
      selections,
    },
  };
};

export const transformUserSelectionsToSummaryItems: TransformUserSelectionsToSummaryItemsFn = ({
  buildProductPropsSelections,
  priceForComboSlotSelection,
  selectedProduct,
  userSelections,
}) => {
  let price = 0;
  const comboSlotEntries = userSelections.comboSlot?.entries() || [];
  return Array.from(comboSlotEntries).map(([slotKey, { selectedItem, comboSlot }]) => {
    const modifierSelections = userSelections.modifiers[slotKey];
    const selections = buildProductPropsSelections(
      modifierSelections,
      selectedItem
    ) as ILegacySelections[];

    if (!selectedItem && comboSlot) {
      return {
        productListItemProps: transformComboSlotToProductListItem({
          comboSlot,
          selectedProduct,
          selections,
        }),
        slotKey,
      };
    }

    if (comboSlot) {
      const comboSlotOption = getComboSlotOptionFromItem(comboSlot, selectedItem as IItem);
      price = priceForComboSlotSelection({
        combo: selectedProduct as ICombo,
        comboSlot,
        selectedOption: comboSlotOption,
      });
    }

    // Adds modifier prices
    if (selections?.length) {
      price += selections.reduce((total, modifier) => total + modifier.price, 0);
    }

    const isCustomizableItem = !!selectedItem && ProductWizardUtils.IsCustomizable(selectedItem);
    const isCustomizableComboSlot = !!comboSlot && ProductWizardUtils.IsCustomizable(comboSlot);

    const productListItemProps = transformItemToProductListItemProps(selectedItem as IItem, {
      productNote: comboSlot?.name.locale,
      isExpandable: isCustomizableItem || isCustomizableComboSlot,
      selections,
      price,
    });

    return {
      productListItemProps,
      slotKey,
    };
  });
};
